import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';
import type { RosterView } from '@/features/flowsheets/CareRoster';
import { PatientsPage } from '@/features/emr/pages/PatientsPage';

export const Route = createFileRoute('/_authenticated/patients/')({
  component: PatientsPage,
  validateSearch: (search: Record<string, unknown>): { roster?: RosterView } => ({
    roster: z
      .object({
        status: z.string().max(40),
        filter: z.string().max(40),
        sort: z.array(z.string().max(80)).max(5),
        search: z.string().max(100),
      })
      .optional()
      .catch(undefined)
      .parse(search.roster),
  }),
  beforeLoad: () => ({
    breadcrumbs: [{ href: '/patients', title: 'Patients' }],
  }),
});
